import React, { useEffect, useState } from 'react';
import {
  Breadcrumb,
  Button,
  Collapse,
  ConfigProvider,
  Form,
  Input,
  Select,
  Space,
  Switch,
} from 'antd';
import { DotChartOutlined, HomeOutlined, SaveOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import Bread from 'modules/layoutModule/components/Bread/Bread';
import plPL from 'antd/lib/locale/pl_PL';
import 'moment/locale/pl';
import {
  createFertilizersGardenRequest,
} from '../requests/fertilizersGardenRequests';
import {
  getFertilizersCategoriesRequest,
  getPackRequest,
  getParametersRequest,
  getPlantsRequest,
} from '../requests/fertilizersRequests';
import 'moment-timezone';
import FormCoverUpload from 'modules/galleryModules/components/FormCoverUpload';
import { FieldData } from 'rc-field-form/lib/interface';
import TextEditor from 'modules/layoutModule/components/TextEditor/TextEditor';
import copyToClipboard from 'helpers/copyToClipboard';
import FormFileUpload from 'modules/galleryModules/components/FormFileUpload';

const { TextArea } = Input;
const { Panel } = Collapse;

const GardenFertilizersAdd = (): JSX.Element => {
  const [isSaveButtonLoading, toggleButtonLoading] = useState(false);
  const [form] = Form.useForm();
  const [fileImage1, setFileImage1] = useState<string | null>(null);
  const [fileImage2, setFileImage2] = useState<string | null>(null);
  const [fileImage3, setFileImage3] = useState<string | null>(null);
  const [fileImage4, setFileImage4] = useState<string | null>(null);
  const [fileImage5, setFileImage5] = useState<string | null>(null);
  const [fileImage6, setFileImage6] = useState<string | null>(null);
const [fileImage7, setFileImage7] = useState<string | null>(null);
  const [fileImage8, setFileImage8] = useState<string | null>(null);
  const [fileImage9, setFileImage9] = useState<string | null>(null);
  const [fileImage10, setFileImage10] = useState<string | null>(null);
  const [fileImage11, setFileImage11] = useState<string | null>(null);
  const [fileImage12, setFileImage12] = useState<string | null>(null);
  const [fileImage13, setFileImage13] = useState<string | null>(null);
  const [fileImage14, setFileImage14] = useState<string | null>(null);
  const [fileImage15, setFileImage15] = useState<string | null>(null);

  const [file1, setFile1] = useState<string | null>(null);
  const [file2, setFile2] = useState<string | null>(null);
  const [file3, setFile3] = useState<string | null>(null);
  const [file4, setFile4] = useState<string | null>(null);
  const [file5, setFile5] = useState<string | null>(null);

  const [fields, setFields] = useState<FieldData[]>([]);
  const [categories, setCategories] = useState([]);
  const [parameters, setParameters] = useState([]);
  const [plants, setPlants] = useState([]);
  const [pack, setPack] = useState([]);
  const [packWithEmpty, setPackWithEmpty] = useState([]);

  const updateFile = (
    e: string,
    field: string,
    coverMethod: (value: string) => void
  ) => {
    setFields([
      {
        name: [field],
        value: e,
      },
    ]);
    coverMethod(e);
  };

  const validateMessages = {
    required: 'Proszę uzupełnić pole ${label}!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!',
    },
    number: {
      range: '${label} must be between ${min} and ${max}',
    },
  };

  const onContentEdit = (e: any, field: string) => {
    setFields([
      {
        name: [field],
        value: e,
      },
    ]);
  };

  useEffect(() => {
    getPackRequest().then((response) => {
      if (response) {
        // @ts-ignore
        const onlyActivePacks = response.data.filter((pack) => pack.isActive);
        const packages = onlyActivePacks.map((section: any) => {
          return {
            label: section.name,
            value: section.id,
          };
        });
        setPack(packages);
        const sectionsWithEmpty = [...packages];
        sectionsWithEmpty.unshift({ label: '', value: '' });
        // @ts-ignore
        setPackWithEmpty(sectionsWithEmpty);
      }
    });

    getParametersRequest().then((response) => {
      if (response) {
        const sections = response.map((section: any) => {
          return {
            label: section.name,
            value: section.id,
          };
        });
        sections.unshift({ label: '', value: '' });
        setParameters(sections);
      }
    });

    getFertilizersCategoriesRequest().then((response) => {
      if (response) {
        const sections = response.data.map(
          (section: { name: string; id: number; subCatName?: string }) => {
            return {
              label: `${section.name} ${section.subCatName ? `/ ${section.subCatName}` : ``
                }`,
              value: section.id,
            };
          }
        );
        setCategories(sections);
      }
    });

    getPlantsRequest().then((response) => {
      if (response) {
        const sections = response.map(
          (section: { name: string; id: number }) => {
            return {
              label: section.name,
              value: section.id,
            };
          }
        );
        sections.unshift({ label: '', value: '' });
        setPlants(sections);
      }
    });
  }, []);

const onSubmitForm = (values: any) => {
    toggleButtonLoading(true);
    createFertilizersGardenRequest(values).then(() => {
      form.resetFields();
      setFileImage1(null);
      setFileImage2(null);
      setFileImage3(null);
      setFileImage4(null);
      setFileImage5(null);
      setFileImage6(null);
      setFileImage7(null);
      setFileImage8(null);
      setFileImage9(null);
      setFileImage10(null);
      setFileImage11(null);
      setFileImage12(null);
      setFileImage13(null);
      setFileImage14(null);
      setFileImage15(null);
      toggleButtonLoading(false);
    });
  };

  const updateCover = (
    e: string,
    field: string,
    coverMethod: (value: string) => void
  ) => {
    setFields([
      {
        name: [field],
        value: e,
      },
    ]);
    coverMethod(e);
  };

  return (
    <>
      <Bread>
        <>
          <Breadcrumb.Item>
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>Nawozy GARDEN</Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/garden/fertilizers">Nawozy GARDEN</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/garden/fertilizers/add">Dodaj</Link>
          </Breadcrumb.Item>
        </>
      </Bread>
      <div className="site-layout-background">
        <ConfigProvider locale={plPL}>
          <Form
            layout="vertical"
            validateMessages={validateMessages}
            onFinish={onSubmitForm}
            form={form}
            fields={fields}
          >
            <Form.Item
              name="category"
              label="Kategoria / Podkategoria"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Wybierz kategorię"
                optionFilterProp="children"
                options={categories}
                filterOption={(input, option) => {
                  // @ts-ignore
                  if (option?.label) {
                    // @ts-ignore
                    return option.label
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }
                  return false;
                }}
              />
            </Form.Item>
            <Form.Item
              name="parameters"
              label="Połącz z parametrami do porównywarki"
            >
              <Select
                showSearch
                placeholder="Wybierz parametry"
                optionFilterProp="children"
                options={parameters}
                filterOption={(input, option) => {
                  // @ts-ignore
                  if (option?.label) {
                    // @ts-ignore
                    return option.label
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }
                  return false;
                }}
              />
            </Form.Item>
            <Form.Item
              name="name"
              label="Nazwa w sliderze"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="name2"
              label="Nazwa na podstronie produktu"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item name="chemicalFormula" label="Formuła nawozu">
              <Input />
            </Form.Item>
            <Form.Item name="picto_ce" label="Piktogram pod formułą nawozu">
              <FormCoverUpload
                cover={fileImage4}
                setCover={(e) => updateCover(e, 'picto_ce', setFileImage4)}
                isNew
                field="picto_ce"
                number={4}
                hideTags
                originalFile
              />
            </Form.Item>
            <Form.Item
              name="image1"
              label="Opakowanie główne PNG"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <FormCoverUpload
                cover={fileImage1}
                setCover={(e) => updateCover(e, 'image1', setFileImage1)}
                isNew
                field="image1"
                number={1}
                asPng
                hideTags
              />
            </Form.Item>
            <Form.Item name="image2" label="Opakowanie dodatkowe 1 PNG">
              <FormCoverUpload
                cover={fileImage2}
                setCover={(e) => updateCover(e, 'image2', setFileImage2)}
                isNew
                field="image2"
                number={2}
                asPng
                hideTags
              />
            </Form.Item>
            <Form.Item name="image3" label="Opakowanie dodatkowe 2 PNG">
              <FormCoverUpload
                cover={fileImage3}
                setCover={(e) => updateCover(e, 'image3', setFileImage3)}
                isNew
                field="image3"
                number={3}
                asPng
                hideTags
              />
            </Form.Item>
            <Form.Item
              name="productPackIcon1"
              label="Piktogram opakowania 1"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Wybierz productPackIcon"
                optionFilterProp="children"
                options={pack}
                filterOption={(input, option) => {
                  // @ts-ignore
                  if (option?.label) {
                    // @ts-ignore
                    return option.label
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }
                  return false;
                }}
              />
            </Form.Item>
            <Form.Item name="productPackIcon2" label="Piktogram opakowania 2">
              <Select
                showSearch
                placeholder="Wybierz productPackIcon"
                optionFilterProp="children"
                options={packWithEmpty}
                filterOption={(input, option) => {
                  // @ts-ignore
                  if (option?.label) {
                    // @ts-ignore
                    return option.label
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }
                  return false;
                }}
              />
            </Form.Item>
            <Form.Item name="productPackIcon3" label="Piktogram opakowania 3">
              <Select
                showSearch
                placeholder="Wybierz productPackIcon"
                optionFilterProp="children"
                options={packWithEmpty}
                filterOption={(input, option) => {
                  // @ts-ignore
                  if (option?.label) {
                    // @ts-ignore
                    return option.label
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }
                  return false;
                }}
              />
            </Form.Item>
            <Form.Item name="productPackIcon4" label="Piktogram opakowania 4">
              <Select
                showSearch
                placeholder="Wybierz productPackIcon"
                optionFilterProp="children"
                options={packWithEmpty}
                filterOption={(input, option) => {
                  // @ts-ignore
                  if (option?.label) {
                    // @ts-ignore
                    return option.label
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }
                  return false;
                }}
              />
            </Form.Item>
            <Form.Item name="productPackIcon5" label="Piktogram opakowania 5">
              <Select
                showSearch
                placeholder="Wybierz productPackIcon"
                optionFilterProp="children"
                options={packWithEmpty}
                filterOption={(input, option) => {
                  // @ts-ignore
                  if (option?.label) {
                    // @ts-ignore
                    return option.label
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }
                  return false;
                }}
              />
            </Form.Item>
            <Form.Item name="productPackIcon6" label="Piktogram opakowania 6">
              <Select
                showSearch
                placeholder="Wybierz productPackIcon"
                optionFilterProp="children"
                options={packWithEmpty}
                filterOption={(input, option) => {
                  // @ts-ignore
                  if (option?.label) {
                    // @ts-ignore
                    return option.label
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }
                  return false;
                }}
              />
            </Form.Item>
            <Form.Item
              name="description"
              label="Podstawowe informacje"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              {/* @ts-ignore */}
              <TextEditor
                onChange={(e) => onContentEdit(e, 'description')}
                disableGallery
              />
            </Form.Item>
            <Form.Item name="properties" label="Właściwości i skład">
              {/* @ts-ignore */}
              <TextEditor
                onChange={(e) => onContentEdit(e, 'properties')}
                disableGallery
              />
            </Form.Item>
            <Form.Item name="benefits" label="Korzyści ze stosowania">
              {/* @ts-ignore */}
              <TextEditor
                onChange={(e) => onContentEdit(e, 'benefits')}
                disableGallery
              />
            </Form.Item>
            <Form.Item name="howToUse" label="Przeznaczenie i stosowanie">
              {/* @ts-ignore */}
              <TextEditor
                onChange={(e) => onContentEdit(e, 'howToUse')}
                disableGallery
              />
            </Form.Item>
            <Form.Item
              name="use"
              label="Nazwa tytułu powiązanych upraw nawożenia"
            >
              <Input />
            </Form.Item>
            <Form.Item name="plantsUse1" label="Połącz z nawożeniem uprawy 1">
              <Select
                showSearch
                placeholder="Wybierz plantsUse"
                optionFilterProp="children"
                options={plants}
                filterOption={(input, option) => {
                  // @ts-ignore
                  if (option?.label) {
                    // @ts-ignore
                    return option.label
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }
                  return false;
                }}
              />
            </Form.Item>
            <Form.Item name="plantsUse2" label="Połącz z nawożeniem uprawy 2">
              <Select
                showSearch
                placeholder="Wybierz plantsUse"
                optionFilterProp="children"
                options={plants}
                filterOption={(input, option) => {
                  // @ts-ignore
                  if (option?.label) {
                    // @ts-ignore
                    return option.label
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }
                  return false;
                }}
              />
            </Form.Item>
            <Form.Item name="plantsUse3" label="Połącz z nawożeniem uprawy 3">
              <Select
                showSearch
                placeholder="Wybierz plantsUse"
                optionFilterProp="children"
                options={plants}
                filterOption={(input, option) => {
                  // @ts-ignore
                  if (option?.label) {
                    // @ts-ignore
                    return option.label
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }
                  return false;
                }}
              />
            </Form.Item>
            <Form.Item name="plantsUse4" label="Połącz z nawożeniem uprawy 4">
              <Select
                showSearch
                placeholder="Wybierz plantsUse"
                optionFilterProp="children"
                options={plants}
                filterOption={(input, option) => {
                  // @ts-ignore
                  if (option?.label) {
                    // @ts-ignore
                    return option.label
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }
                  return false;
                }}
              />
            </Form.Item>
            <Form.Item name="plantsUse5" label="Połącz z nawożeniem uprawy 5">
              <Select
                showSearch
                placeholder="Wybierz plantsUse"
                optionFilterProp="children"
                options={plants}
                filterOption={(input, option) => {
                  // @ts-ignore
                  if (option?.label) {
                    // @ts-ignore
                    return option.label
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }
                  return false;
                }}
              />
            </Form.Item>
            <Form.Item
              name="package"
              label="Informacje uzupełniające / Pakowanie, transport i przechowywanie"
            >
              {/* @ts-ignore */}
              <TextEditor
                onChange={(e) => onContentEdit(e, 'package')}
                disableGallery
              />
            </Form.Item>
            <Form.Item
              name="additionalPictogram1"
              label="Przechowywanie w opakowaniu 1"
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="uploadFilePictogram1"
              label="Piktogramy przechowywania 1"
            >
              <FormCoverUpload
                cover={fileImage5}
                setCover={(e) =>
                  updateCover(e, 'uploadFilePictogram1', setFileImage5)
                }
                isNew
                field="uploadFilePictogram1"
                number={5}
                hideTags
                originalFile
              />
            </Form.Item>
            <Form.Item
              name="additionalPictogram2"
              label="Przechowywanie w opakowaniu 2"
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="uploadFilePictogram2"
              label="Piktogramy przechowywania 2"
            >
              <FormCoverUpload
                cover={fileImage6}
                setCover={(e) =>
                  updateCover(e, 'uploadFilePictogram2', setFileImage6)
                }
                isNew
                field="uploadFilePictogram2"
                number={6}
                hideTags
                originalFile
              />
            </Form.Item>
            <Form.Item
              name="additionalPictogram3"
              label="Przechowywanie w opakowaniu 3"
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="uploadFilePictogram3"
              label="Piktogramy przechowywania 3"
            >
              <FormCoverUpload
                cover={fileImage7}
                setCover={(e) =>
                  updateCover(e, 'uploadFilePictogram3', setFileImage7)
                }
                isNew
                field="uploadFilePictogram3"
                number={7}
                hideTags
                originalFile
              />
            </Form.Item>
            <Form.Item
              name="additionalPictogram4"
              label="Przechowywanie w opakowaniu 4"
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="uploadFilePictogram4"
              label="Piktogramy przechowywania 4"
            >
              <FormCoverUpload
                cover={fileImage8}
                setCover={(e) =>
                  updateCover(e, 'uploadFilePictogram4', setFileImage8)
                }
                isNew
                field="uploadFilePictogram4"
                number={8}
                hideTags
                originalFile
              />
            </Form.Item>
            <Form.Item
              name="additionalPictogram5"
              label="Przechowywanie w opakowaniu 5"
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="uploadFilePictogram5"
              label="Piktogramy przechowywania 5"
            >
              <FormCoverUpload
                cover={fileImage9}
                setCover={(e) =>
                  updateCover(e, 'uploadFilePictogram5', setFileImage9)
                }
                isNew
                field="uploadFilePictogram5"
                number={9}
                hideTags
                originalFile
              />
            </Form.Item>
            <Form.Item
              name="additionalPictogram6"
              label="Przechowywanie w opakowaniu 6"
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="uploadFilePictogram6"
              label="Piktogramy przechowywania 6"
            >
              <FormCoverUpload
                cover={fileImage10}
                setCover={(e) =>
                  updateCover(e, 'uploadFilePictogram6', setFileImage10)
                }
                isNew
                field="uploadFilePictogram6"
                number={10}
                hideTags
                originalFile
              />
            </Form.Item>
            <Form.Item
              name="safety"
              label="Informacje uzupełniające / Środki ostrożności"
            >
              {/* @ts-ignore */}
              <TextEditor
                onChange={(e) => onContentEdit(e, 'safety')}
                disableGallery
              />
            </Form.Item>
            <br />
            Informacje uzupełniające / Pliki do pobrania
            <Form.Item
              name="nameUploadedFile1"
              label="Nazwa pliku do pobrania 1"
            >
              <Input />
            </Form.Item>
            <Form.Item name="uploadedFile1" label="Plik do pobrania 1 PDF">
              <FormFileUpload
                file={file1}
                setFile={(e) => updateFile(e, 'uploadedFile1', setFile1)}
                isNew
                field="file1"
              />
            </Form.Item>
            <Form.Item
              name="nameUploadedFile2"
              label="Nazwa pliku do pobrania 2"
            >
              <Input />
            </Form.Item>
            <Form.Item name="uploadedFile2" label="Plik do pobrania 2 PDF">
              <FormFileUpload
                file={file2}
                setFile={(e) => updateFile(e, 'uploadedFile2', setFile2)}
                isNew
                field="file2"
              />
            </Form.Item>
            <Form.Item
              name="nameUploadedFile3"
              label="Nazwa pliku do pobrania 3"
            >
              <Input />
            </Form.Item>
            <Form.Item name="uploadedFile3" label="Plik do pobrania 3 PDF">
              <FormFileUpload
                file={file3}
                setFile={(e) => updateFile(e, 'uploadedFile3', setFile3)}
                isNew
                field="file3"
              />
            </Form.Item>
            <Form.Item
              name="nameUploadedFile4"
              label="Nazwa pliku do pobrania 4"
            >
              <Input />
            </Form.Item>
            <Form.Item name="uploadedFile4" label="Plik do pobrania 4 PDF">
              <FormFileUpload
                file={file4}
                setFile={(e) => updateFile(e, 'uploadedFile4', setFile4)}
                isNew
                field="file4"
              />
</Form.Item>
            <Form.Item
              name="nameUploadedFile5"
              label="Nazwa pliku do pobrania 5"
            >
              <Input />
            </Form.Item>
            <Form.Item name="uploadedFile5" label="Plik do pobrania 5 PDF">
              <FormFileUpload
                file={file5}
                setFile={(e) => updateFile(e, 'uploadedFile5', setFile5)}
                isNew
                field="file5"
              />
            </Form.Item>
            <br />
            Galeria
            <Form.Item name="fileImage1" label="Plik galerii 1">
              <FormCoverUpload
                cover={fileImage11}
                setCover={(e) => updateCover(e, 'fileImage1', setFileImage11)}
                isNew
                field="fileImage1"
                number={11}
                hideTags
              />
            </Form.Item>
            <Form.Item name="fileImage2" label="Plik galerii 2">
              <FormCoverUpload
                cover={fileImage12}
                setCover={(e) => updateCover(e, 'fileImage2', setFileImage12)}
                isNew
                field="fileImage2"
                number={12}
                hideTags
              />
            </Form.Item>
            <Form.Item name="fileImage3" label="Plik galerii 3">
              <FormCoverUpload
                cover={fileImage13}
                setCover={(e) => updateCover(e, 'fileImage3', setFileImage13)}
                isNew
                field="fileImage3"
                number={13}
                hideTags
              />
            </Form.Item>
            <Form.Item name="fileImage4" label="Plik galerii 4">
              <FormCoverUpload
                cover={fileImage14}
                setCover={(e) => updateCover(e, 'fileImage4', setFileImage14)}
                isNew
                field="fileImage4"
                number={14}
                hideTags
              />
            </Form.Item>
            <Form.Item name="fileImage5" label="Plik galerii 5">
              <FormCoverUpload
                cover={fileImage15}
                setCover={(e) => updateCover(e, 'fileImage5', setFileImage15)}
                isNew
                field="fileImage5"
                number={15}
                hideTags
              />
            </Form.Item>
            <div className="tables-collapse">
              <Collapse defaultActiveKey={[]}>
                <Panel header="Tabelka 1" key="1" forceRender>
                  <Form.Item name="table1" label="Tabelka 1">
                    <TextArea rows={4} />
                  </Form.Item>
                  <Button
                    type="link"
                    onClick={() => copyToClipboard('TABELKA#1')}
                    style={{ padding: 0, margin: 0 }}
                  >
                    TABELKA#1
                  </Button>
                </Panel>
<Panel header="Tabelka 2" key="2" forceRender>
                  <Form.Item name="table2" label="Tabelka 2">
                    <TextArea rows={4} />
                  </Form.Item>
                  <Button
                    type="link"
                    onClick={() => copyToClipboard('TABELKA#2')}
                    style={{ padding: 0, margin: 0 }}
                  >
                    TABELKA#2
                  </Button>
                </Panel>
                <Panel header="Tabelka 3" key="3" forceRender>
                  <Form.Item name="table3" label="Tabelka 3">
                    <TextArea rows={4} />
                  </Form.Item>
                  <Button
                    type="link"
                    onClick={() => copyToClipboard('TABELKA#3')}
                    style={{ padding: 0, margin: 0 }}
                  >
                    TABELKA#3
                  </Button>
                </Panel>
                <Panel header="Tabelka 4" key="4" forceRender>
                  <Form.Item name="table4" label="Tabelka 4">
                    <TextArea rows={4} />
                  </Form.Item>
                  <Button
                    type="link"
                    onClick={() => copyToClipboard('TABELKA#4')}
                    style={{ padding: 0, margin: 0 }}
                  >
                    TABELKA#4
                  </Button>
                </Panel>
                <Panel header="Tabelka 5" key="5" forceRender>
                  <Form.Item name="table5" label="Tabelka 5">
                    <TextArea rows={4} />
                  </Form.Item>
                  <Button
                    type="link"
                    onClick={() => copyToClipboard('TABELKA#5')}
                    style={{ padding: 0, margin: 0 }}
                  >
                    TABELKA#5
                  </Button>
                </Panel>
                <Panel header="Tabelka 6" key="6" forceRender>
                  <Form.Item name="table6" label="Tabelka 6">
                    <TextArea rows={4} />
                  </Form.Item>
                  <Button
                    type="link"
                    onClick={() => copyToClipboard('TABELKA#6')}
                    style={{ padding: 0, margin: 0 }}
                  >
                    TABELKA#6
                  </Button>
                </Panel>
                <Panel header="Tabelka 7" key="7" forceRender>
                  <Form.Item name="table7" label="Tabelka 7">
                    <TextArea rows={4} />
                  </Form.Item>
                  <Button
                    type="link"
                    onClick={() => copyToClipboard('TABELKA#7')}
                    style={{ padding: 0, margin: 0 }}
                  >
                    TABELKA#7
                  </Button>
                </Panel>
                <Panel header="Tabelka 8" key="8" forceRender>
                  <Form.Item name="table8" label="Tabelka 8">
                    <TextArea rows={4} />
                  </Form.Item>
                  <Button
                    type="link"
                    onClick={() => copyToClipboard('TABELKA#8')}
                    style={{ padding: 0, margin: 0 }}
                  >
                    TABELKA#8
                  </Button>
                </Panel>
                <Panel header="Tabelka 9" key="9" forceRender>
                  <Form.Item name="table9" label="Tabelka 9">
                    <TextArea rows={4} />
                  </Form.Item>
                  <Button
                    type="link"
                    onClick={() => copyToClipboard('TABELKA#9')}
                    style={{ padding: 0, margin: 0 }}
                  >
                    TABELKA#9
                  </Button>
                </Panel>
                <Panel header="Tabelka 10" key="10" forceRender>
                  <Form.Item name="table10" label="Tabelka 10">
                    <TextArea rows={4} />
                  </Form.Item>
                  <Button
                    type="link"
                    onClick={() => copyToClipboard('TABELKA#10')}
                    style={{ padding: 0, margin: 0 }}
                  >
                    TABELKA#10
                  </Button>
                </Panel>
              </Collapse>
            </div>
            <Form.Item
              name="sortOrder"
              label="Kolejność"
              rules={[
                {
                  required: true,
                },
                {
                  validator: async (_, value) => {
                    if (value) {
                      if (
                        (value.length > 5 ||
                          !/^[0-9]*\,?\.?[0-9]*$/.test(value)) &&
                        value.length > 0
                      ) {
                        return Promise.reject(
                          new Error('Proszę podać poprawną wartość!')
                        );
                      }
                    }
                  },
                },
              ]}
            >
              <Input
                style={{
                  width: '100px',
                }}
              />
            </Form.Item>
            <Form.Item
              name="isActive"
              label="Widoczność"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
            <Form.Item>
              <Space>
                <Button
                  type="primary"
                  htmlType="submit"
                  icon={<SaveOutlined />}
                  loading={isSaveButtonLoading}
                >
                  Zapisz
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </ConfigProvider>
      </div>
    </>
  );
};

export default GardenFertilizersAdd;
